module.exports = __webpack_public_path__ + "static/media/storageph.ba743379.png";